import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "core/store";

const authReducer = (state: RootState) => state.auth;

export const authSessionIdSelector = createSelector(authReducer, (state) => {
	return state.sessionId;
});

export const authUserSelector = createSelector(authReducer, (state) => {
	return state.user;
});

export const authRecuperaPraticaEmailSelector = createSelector(
	authReducer,
	(state) => {
		return state.recuperaPraticaEmail;
	}
);
